import React from 'react';
import classnames from 'classnames';
import { useConfigService } from '@thd-nucleus/experience-context';
import { Typography, Tooltip } from '@one-thd/sui-atomic-components';
import { Price } from '@thd-olt-component-react/price';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
// import { ConsumerCardMessaging } from '@thd-olt-component-react/consumer-card-messaging';
import { Delivery } from '@one-thd/sui-icons';
import { getPricingInfo } from '@thd-olt-component-react/product-set';
import { onAddToCartClick, getPricing, getDeliveryMessaging } from '../../utils';
import { useApplianceBundles } from '../ApplianceBundlesProvider';

export const Buybox = () => {
  const {
    itemId,
    storeId,
    channel,
    cartOptions,
    cartReqParams,
    selectedItems,
    hasMobileView,
    hasTabletView,
    enableApplianceDeliveryCharge,
    enableFreeDeliveryForExchange,
    applianceDeliveryChargeValue,
    isExchangeCustomer,
    metadata
  } = useApplianceBundles();

  const applianceDeliveryThreshold = useConfigService('applianceDeliveryThreshold')
    ?? 396;

  const { mapDetail, hideTotal } = getPricingInfo(
    selectedItems.map(({ product }) => product),
    enableApplianceDeliveryCharge,
    enableFreeDeliveryForExchange,
    applianceDeliveryChargeValue,
    isExchangeCustomer,
    applianceDeliveryThreshold
  );
  const pricing = getPricing(selectedItems, mapDetail);

  const buyboxClassNames = classnames('sui-my-auto sui-mx-0', {
    'sui-w-80': !hasMobileView,
    'sui-max-w-sm': hasMobileView,
    'sui-pt-8': hasTabletView
  });

  const {
    deliveryMessage,
    showIcon,
    showMessaging
  } = getDeliveryMessaging(pricing?.pricing?.original || pricing?.pricing?.value,
    enableApplianceDeliveryCharge, enableFreeDeliveryForExchange, isExchangeCustomer,
    applianceDeliveryThreshold
  );

  return (
    <>
      <div
        className={buyboxClassNames}
        data-testid="appliance-bundles-buybox"
      >
        <div className={classnames({ 'sui-mb-2': !showMessaging })}>
          {hideTotal ? (
            <>
              {/* eslint-disable max-len */}
              <Tooltip title="We've set this item's price lower than the manufacturer will let us advertise, so you'll have to add it to your cart to see our price. If you decide you don't want to purchase the item, you can remove it from your cart.">
                <Typography component="span" weight="bold" tabIndex="0" role="button" decoration="underline">
                  See Lower Price In Cart
                </Typography>
              </Tooltip>
            </>
          ) : (
            <>
              <Typography>
                Price for Bundle:
              </Typography>
              <Price
                basic
                large
                channel={channel}
                itemId={itemId}
                product={pricing}
                displayEachUom={false}
                storeId={storeId}
                hideBadge
                disableOuterSpacing
              />
            </>
          )}

        </div>
        {showMessaging && (
          <span className="sui-flex sui-gap-2 sui-mt-1 sui-mb-2">
            {showIcon && (
              <span className="sui-fill-success-strong">
                <Delivery color="inherit" />
              </span>
            )}
            <Typography color="success">{deliveryMessage}</Typography>
          </span>
        )}
        {/* re-add 'sui-pb-5' as default classname when CCM/PLCC is fixed */}
        <div className={classnames({
          'sui-w-80': !hasMobileView
        })}
        >
          <AddToCart
            cartOptions={cartOptions}
            cartReqParams={cartReqParams}
            onClick={() => onAddToCartClick(selectedItems, metadata)}
            outline
            variant="secondary"
            small={false}
          >
            Add Bundle to Cart
          </AddToCart>
        </div>
        {/* TODO: Hidden for now, future work to unlock this functionality within CCM/PLCC */}
        {/* <ConsumerCardMessaging
          itemId={itemId}
          bundlePrice={pricing.pricing.mapAboveOriginalPrice ? '100.00' : pricing.pricing.value}
          paymentEstimatorVersion="v1.5.0"
          isB2B={isB2BCustomer}
          isAppliance
        /> */}
      </div>
    </>
  );
};
